import { render } from "./newsletter-signup.vue?vue&type=template&id=5710cc2e"
import script from "./newsletter-signup.vue?vue&type=script&lang=js"
export * from "./newsletter-signup.vue?vue&type=script&lang=js"

import "./newsletter-signup.vue?vue&type=style&index=0&id=5710cc2e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__